import React, { useState, useRef } from 'react'
import '../../assets/styles/enrichment.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { commonService } from '../../services/otherServices';
import Advertisment from '../../components/Common/Advertisment';
import Popup from '../../components/Common/Error'
import axios, { AxiosError } from "axios";

const Dashboard = () => {

    const [showAvailPopup, setShowAvailUpdatePopup] = useState(false);
    const [showContactPopup, setShowContactUpdatePopup] = useState(false);
    const [showSubmitPopup, setShowSubmitPopup] = useState(false);
    const [fileName, setFileName] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    interface FormData {
        no_of_contacts: string;
        criteria: string;
        file: File | null;
    }

    const [formData, setFormData] = useState<FormData>({
        no_of_contacts: '',
        criteria: '',
        file: null
    });

    const requiredFields: (keyof FormData)[] = [
        "no_of_contacts",
        "criteria",
        "file"
    ];

    const isFormComplete = requiredFields.every(field => {
        if (field === "file") {
            return formData.file !== null;
        }
        return formData[field].trim() !== "";
    });


    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;

        // allow only numbers for no_of_contacts
        if (name === "no_of_contacts" && !/^\d*$/.test(value)) {
            return;
        }
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const submitDataEnrichmentRequest = async () => {
        if(!isFormComplete) return;
        // Here you can handle the form submission, e.g., send data to the server
        try {
            setIsLoading(true);
            const response = await commonService.dataEnrichment(formData);
            if (response && response?.data?.status === 'failed') {
                setErrorMsg('Failed to submit request');
                return;
            }
            setShowSubmitPopup(true)
            setFormData({
                no_of_contacts: '',
                criteria: '',
                file: null
            });

            setFileName('');

            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const errorData = err.response?.data;

                if (errorData?.details?.length) {
                    setErrorMsg(errorData.details[0]?.input?.message);
                } else if (errorData?.message) {
                    setErrorMsg(errorData.message);
                } else {
                    setErrorMsg("Something went wrong");
                }
            } else {
                setErrorMsg("Unexpected error occurred");
            }
        } finally {
            setIsLoading(false);
        }

    }

    return (
        <>
            <div className="container">

                <Advertisment />

                <div className="enrichment-white-box">
                    <div className="enrichment-box">
                        <div>
                            <p className="your-data">Request a Data Enrichment Consultation</p>
                            <p className="track">Enhance your existing contact database with verified, up-to-date, and actionable insights.</p>
                        </div>

                        <div className="">
                            <div className="enrichment-form">

                                <div className="row">
                                    {/* Top inputs */}
                                    <div className="col-6">
                                        <div className="dashboard-input-group">
                                            <label className="dashboard-input-label">
                                                Number of Contacts to Enrich*
                                            </label>
                                            <input
                                                type="text"
                                                className="dashboard-input"
                                                placeholder="Enter number of records you'd like us to process"
                                                onChange={handleChange}
                                                value={formData.no_of_contacts}
                                                name="no_of_contacts"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-6">
                                        <div className="dashboard-input-group">
                                            <label className="dashboard-input-label">
                                                Upload Your Test File*
                                            </label>

                                            <div className="upload-input-wrapper">
                                                <input
                                                    type="text"
                                                    className="dashboard-input upload-text-input"
                                                    placeholder="Upload a CSV file for evaluation"
                                                    readOnly
                                                    value={fileName}
                                                />

                                                <label className={`upload-btnnn ${isLoading ? "disabled" : ""}`}>
                                                    Upload
                                                    <input
                                                        ref={fileInputRef}
                                                        type="file"
                                                        accept=".csv"
                                                        disabled={isLoading}
                                                        hidden
                                                        // disabled={!isFormComplete}
                                                        onChange={(e) => {
                                                            if (e.target.files?.[0]) {
                                                                const file = e.target.files[0];
                                                                setFileName(file.name);
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    file
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                </label>
                                            </div>
                                        </div>

                                    </div>

                                    {/* Full width textarea at bottom */}
                                    <div className="col-12 mt-3">
                                        <div className="dashboard-input-group-1 w-100">
                                            <label className="dashboard-input-label">
                                                Describe Your Requirement*
                                            </label>
                                            <textarea
                                                className="dashboard-input enrichment-textarea w-100"
                                                placeholder="Tell us what kind of data attributes you’d like to enrich — such as job titles, company details, revenue, phone numbers, or verified emails."
                                                onChange={handleChange}
                                                value={formData.criteria}
                                                name="criteria"

                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* SUBMIT */}
                                <div className="d-flex justify-content-center mt-4">
                                    <div>
                                        <button
                                            type="button"
                                            className={`submit-request-btn ${isFormComplete ? 'active' : ''}`}
                                            // disabled={!isFormComplete}
                                            style={{ cursor:!isFormComplete ?"not-allowed":"pointer"}}
                                            onClick={() => submitDataEnrichmentRequest()}
                                        >

                                            {isLoading ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                    Submitting...
                                                </>
                                            ) : (
                                                "Send My Request"
                                            )}
                                        </button>
                                    </div>
                                </div>
                                <p className="our-data" style={{ fontStyle: "italic" }}>Our data experts will review your request and provide a personalized enrichment plan within 24–48 hours.</p>


                                {showSubmitPopup && (
                                    <div className="submit-popup-overlay">
                                        <div className="submit-popup">
                                            {/* Close icon */}
                                            <div className="d-flex justify-content-end">
                                                <img src="/images/close-active.png" alt="" className="submit-popup-close"
                                                    onClick={() => setShowSubmitPopup(false)}
                                                />
                                            </div>

                                            <div className="d-flex justify-content-center">
                                                <img src="/images/hand-shak.png" alt="" />
                                            </div>

                                            {/* Content */}
                                            <p className="submit-popup-title">Success! Your request has been submitted.</p>
                                            <p className="submit-popup-text mt-3"  style={{textAlign:"center"}}>
                                                <span style={{ fontWeight: "100" }}> Our data experts will review your enrichment requirement and get</span><br /><span style={{ fontWeight: "100" }}> back to you within </span><strong>24–48 hours.</strong>
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* error popup */}
            <Popup
                isOpen={!!errorMsg}
                onClose={() => setErrorMsg("")}
                title={errorMsg}
                iconSrc="/images/grey-cancel-cta.png"
            />

        </>
    )
}

export default Dashboard;